import * as LDClient from 'launchdarkly-js-client-sdk'
import { showWarning, throwError } from './utils'

let client: LDClient.LDClient

async function initialize(
  key: string,
  context: LDClient.LDContext,
  options?: LDClient.LDOptions
) {
  if (context.anonymous) {
    showWarning('context.anonymous flag was set to false automatically')
  }

  client = LDClient.initialize(key, { ...context, anonymous: false }, options)

  await client.waitForInitialization()
  return client
}

async function identify(
  context: LDClient.LDContext,
  hash?: string,
  onDone?: (err: Error | null, flags: LDClient.LDFlagSet | null) => void
) {
  if (context.anonymous) {
    showWarning('context.anonymous flag was set to false automatically')
  }

  if (!client) {
    throwError('Launchdarkly was not initialized')
  }

  return client.identify({ ...context, anonymous: false }, hash, onDone)
}

function getFlag<T = boolean>(flag: string): T {
  if (!client) return undefined as unknown as T
  return client.variation(flag, undefined) as T
}

function watchFlag<T = boolean>(
  flag: string,
  onChange: (value: T) => void
): () => void {
  if (!client) return () => {}
  const handler = (current: T) => onChange(current)
  client.on(`change:${flag}` as any, handler)
  return () => client.off(`change:${flag}` as any, handler)
}

function trackLDEvent(key: string, data?: unknown, metricValue?: number): void {
  if (client) client.track(key, data, metricValue)
}

export { initialize, identify, getFlag, watchFlag, trackLDEvent }
